<template>
  <div class="ec-line011">
    <the-heading class="lg:mt-4 lg:mb-8 mt-1 mb-5">{{
      id ? $t('ec-line011.updateHeading') : $t('ec-line011.addHeading')
    }}</the-heading>
    <shipping-form
      :id="id"
      :is-ec-line011-flag="true"
      @submit="onSubmit"
      @cancel="onCancel"
      @delete="onDelete"
      @update-inquiry-status="updateInquiryStatus"
    ></shipping-form>
  </div>
</template>

<script>
import TheHeading from '@/components/my-page-partials/TheHeading.vue'
import ShippingForm from '@/components/ec-line011/ShippingForm.vue'
import { AddressService, InquiryService } from '@/services'
import BreadcrumbMixin from '@/mixins/breadcrumb'
import { trimCommaForm } from '@/utils'
import { PROVIDER, INQUIRY_STATUS_ID, INQUIRY_TYPE_ID, DEFAULT_COUNTRY_ID } from '@/constants'

const target_type_ids = [INQUIRY_TYPE_ID.EMAIL, INQUIRY_TYPE_ID.LINE]

const target_status_ids = [INQUIRY_STATUS_ID.DONE_CORRESPOND]

export default {
  components: { TheHeading, ShippingForm },
  mixins: [BreadcrumbMixin],
  props: {
    id: { type: [Number, String], default: () => null },
  },
  computed: {
    corporateFlag() {
      return this.$store.getters['auth/shop']?.corporate_flag
    },
    businessAccountFlag() {
      return this.$store.getters['auth/user']?.business_account_flag
    },
  },
  methods: {
    async onSubmit(data) {
      const loading = this.$loading({ lock: true })
      try {
        const { subscription_id } = this.$route.query

        if (!this.corporateFlag && this.businessAccountFlag) {
          data.name01 = data.company_name
          data.name02 = ''
          data.kana01 = data.company_name_kana
          data.kana02 = ''
        }
        if (!this.corporateFlag) {
          data.company_name_kana = null
          data.company_name = null
        }
        data.country_id = DEFAULT_COUNTRY_ID
        data.customer_id = this.user.id
        data.address_id = this.id
        data.store_name = this.shopName
        data.update_date = null
        data.prefix_history = this.user.id
        data.business_account_flag = this.businessAccountFlag

        const body = trimCommaForm({
          ...data,
          ...(this.id && { prefix_history_type: subscription_id }),
        })

        let newAddressId
        if (this.id) {
          await AddressService.updateAddress(this.user.id, this.id, body)
        } else {
          const response = await AddressService.newAddress(body)
          newAddressId = response.data.id
        }

        this.id &&
          data.is_update_customer &&
          (await this.$store.dispatch('auth/getAuth', { provider: PROVIDER.CUSTOMER }))

        this.id ? this.upsertAddressId(this.id) : this.upsertAddressId(newAddressId)

        this.id
          ? this.$alert({ message: this.$t('ec-line011.successUpdateMessage'), type: 'success' })
          : this.$alert({ message: this.$t('ec-line011.successAddMessage'), type: 'success' })

        this.onCancel()
      } catch (error) {
        this.handleError({ message: error.response?.data?.meta?.message })
      } finally {
        loading.close()
      }
    },
    onCancel() {
      const { redirect, popup } = this.$route.query
      if (redirect) {
        this.$router.push({
          path: redirect,
          query: {
            popup,
          },
        })
      } else {
        this.$router.back()
      }
    },
    onDelete() {
      this.loading = true
      AddressService.deleleAddress(this.id)
        .then(() => this.$alert({ message: this.$t('ec-line011.deleteShippingSucces'), type: 'success' }))
        .then(() => this.onCancel())
        .catch((error) =>
          this.handleError({
            message: error.response?.data?.meta?.message,
          })
        )
        .finally(() => (this.loading = false))
    },
    async updateInquiryStatus() {
      const body = {
        status_id: this.Constants.INQUIRY_STATUS_ID.DURING_CORRESPOND,
        target_status_ids: target_status_ids,
        target_type_ids: target_type_ids,
        customer_id: this.user.id,
        customer_flag: true,
      }

      InquiryService.updateCustomerInquiryStatus(body)
    },

    upsertAddressId(newData) {
      this.$store.commit('addressUpsert/setAddressId', newData)
    },
  },
  metaInfo() {
    return {
      title: this.$t('ec-line011.title'),
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.id
            ? this.$t('ec-line011.eidtDescription', { shop_name: this.shopName })
            : this.$t('ec-line011.description', { shop_name: this.shopName }),
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: this.id
            ? this.$t('ec-line011.editKeyword', { shop_name: this.shopName })
            : this.$t('ec-line011.keyword', { shop_name: this.shopName }),
        },
      ],
    }
  },
}
</script>

<style></style>
